import React from 'react'

import Layout from '../components/Layout'
import {Posts} from '../components/Main'

const Trending = ({ location }) => {
    return (
        <Layout location={location}>
            <Posts pageTitle={'Trending'} category={['trending']} />
        </Layout>
    )
}

export default Trending
